import { type ReactNode } from 'react'

import { LinkOutbound, LinkRoute } from '@/components/common/Link'
import { type WPPostPreviewType } from '@/defs/wordpress'
import { useLinkInternal } from '@/hooks/useLinkInternal'

type Props = {
  article: WPPostPreviewType
  children: ReactNode
  className?: string
  newTab?: boolean
}

export const ArticlePreviewLink = ({ article, children, className, newTab: newTabProp }: Props) => {
  const { buildRelative } = useLinkInternal()
  const { category, externalLink, slug } = article

  const section = category?.slug === 'guide' ? 'guide' : 'article'

  const newTab = !!externalLink || newTabProp
  const href = externalLink ? externalLink : buildRelative({ articleSlug: slug, section })

  if (!href) return <span className={className}>{children}</span>

  if (newTab) {
    return (
      <LinkOutbound className={className} href={href} utm={{ medium: 'article' }}>
        {children}
      </LinkOutbound>
    )
  }

  return (
    <LinkRoute className={className} href={href}>
      {children}
    </LinkRoute>
  )
}
